import Layout from "@/components/feature/Layout";
import SectionHeader from "@/components/base/SectionHeader";
import CTAButton from "@/components/base/CTAButton";
import WhyEmchon from "@/pages/home/components/WhyEmchon";
import Technology from "@/pages/home/components/Technology";
import FinalCta from "@/pages/home/components/FinalCta";

export default function About() {
  return (
    <Layout>
      <div className="pt-16 md:pt-[72px]">
        <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
          <div className="mx-auto max-w-[1280px]">
            <SectionHeader
              eyebrow="About"
              title="Technology With a Purpose."
            />
          </div>
        </section>

        <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
          <div className="mx-auto max-w-[1280px] grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <p className="text-xl text-foreground-800 leading-relaxed font-medium">
                EMCHON Technologies is a digital solutions company focused on
                helping businesses and organizations use technology more
                effectively.
              </p>
              <div className="mt-6 space-y-4 text-foreground-600 leading-relaxed">
                <p>
                  We believe technology should do more than look good. It should
                  solve problems, simplify processes, improve experiences and
                  create opportunities for growth.
                </p>
                <p>
                  Our work spans professional websites, custom software,
                  automation, AI-powered solutions and digital transformation.
                  We help organizations move from manual, disconnected processes
                  to practical, connected digital systems.
                </p>
                <p>
                  We're a small but highly capable team with ambition, technical
                  depth and a clear long-term vision — building toward becoming a
                  serious digital-solutions partner while delivering real value
                  to every client today.
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-6">
              <div className="rounded-lg border border-background-200 bg-background-100 p-7">
                <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-600 uppercase">
                  <i className="ri-flag-2-line"></i> Our Mission
                </span>
                <p className="mt-3 text-lg text-foreground-800 leading-relaxed">
                  To make practical technology accessible to businesses and
                  organizations that want to grow.
                </p>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-100 p-7">
                <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-600 uppercase">
                  <i className="ri-eye-line"></i> Our Vision
                </span>
                <p className="mt-3 text-lg text-foreground-800 leading-relaxed">
                  To become a trusted technology partner for organizations
                  building the future.
                </p>
              </div>
              <div className="mt-4">
                <CTAButton to="/contact" variant="dark" icon="ri-arrow-right-up-line">
                  Work With Us
                </CTAButton>
              </div>
            </div>
          </div>
        </section>

        <WhyEmchon />

        <Technology />

        <FinalCta />
      </div>
    </Layout>
  );
}